import { bool, func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

function AddCampaignButton({ opportunityId, onRequest, onSuccess, loading }) {
  const onClick = () =>
    onRequest({ data: { opportunityId } })
      .then(campaign => onSuccess(campaign))
      .catch(console.error); // eslint-disable-line no-console

  return (
    <Button color="primary" disabled={loading} onClick={onClick}>
      Create Campaign
    </Button>
  );
}
AddCampaignButton.propTypes = {
  opportunityId: number.isRequired,
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
  loading: bool.isRequired,
};

export default withApiRequest({
  query: api.addCampaign,
  error: 'flash',
  successMessage: 'Created campaign',
})(AddCampaignButton);
